export default __webpack_public_path__ + "static/engelhorn-avatar-150x150-5e6c8314341b1dddb895719178ed2c4e.png";